module.exports = __webpack_public_path__ + "static/media/f8.35646a11.jpg";